// eslint-disable-next-line import/prefer-default-export
export var AVAILABLE_COLOR_VARIANTS = ["inherit", "hiContrast", "primary", "lowContrast", "disabled", "accent", "info", "moderate", "critical", "warning", "success"];